import { render, staticRenderFns } from "./Selection.vue?vue&type=template&id=9d704858&scoped=true"
import script from "./Selection.vue?vue&type=script&lang=js"
export * from "./Selection.vue?vue&type=script&lang=js"
import style0 from "./Selection.vue?vue&type=style&index=0&id=9d704858&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d704858",
  null
  
)

export default component.exports